import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';

import { allProductsState } from '../../recoil/atoms';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import { useLanderControls } from '../LanderContext';
import { ProductReviewQuote } from '../components/ProductReviewQuote';

export const BridalLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero
          heroImage={'mobile-bridal-lander-top-hero-1.jpg'}
          titleElement={
            <>
              Feel your best on <br />
              your big day.
            </>
          }
          heroContainerHeight={`108vw`}
          title={'Feel your best on your big day'}
          subTitle={'Style and support united.'}
        >
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Never rolls
                <br /> down
              </>
            }
            color={'black'}
            labelColor={'black'}
            titleStyles={{ lineHeight: '22px', marginTop: 12, textAlign: 'center' }}
            inlineStyles={{
              mobile: {
                left: `40%`,
                top: `10%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={
              <>
                Comfortable
                <br /> waist shaping
              </>
            }
            titleStyles={{ lineHeight: '22px', marginTop: 12, textAlign: 'center' }}
            labelColor={'black'}
            color={'black'}
            inlineStyles={{
              mobile: {
                left: `54%`,
                top: `34%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={
              <>
                Smoothing
                <br /> mesh
              </>
            }
            labelColor={'black'}
            color={'black'}
            titleStyles={{ lineHeight: '22px', marginTop: 12, textAlign: 'center' }}
            inlineStyles={{
              mobile: {
                left: `14%`,
                top: `56%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-bridal-desktop-1.jpg',
              title: 'Doesn’t roll down',
              description: 'Flexible boning keeps the garment from rolling down.',
            },
            {
              imgName: 'feature-bridal-desktop-2.jpg',
              title: 'Targeted compression',
              description: 'Varied levels of compression shape without squeezing.',
            },
            {
              imgName: 'feature-bridal-desktop-3.jpg',
              title: 'Lingerie-inspired',
              description: 'Luxe fabrics and curve-enhancing designs are sexy and supportive.',
            },
          ]}
        />
        <ProductReviewQuote
          backgroundColor="#D7D1D1"
          leftPanelMaxWidth={'45%'}
          rightPanelMaxWidth={'720px'}
          quotes={[
            {
              quoteText:
                '“Best shapewear I have ever worn. I honestly did not believe the reviews, but this baby stays in place, smooths what needs to be smoothed and was comfortable enough to wear for 12 hours straight."',
              author: '- Michelle D.',
            },
            {
              quoteText: `"The booty is not squished! Finally a brief that doesn't cut in!! Ordered these for my wedding and they are PERFECT. I couldn't be happier."`,
              author: '- Laura W.',
            },
            {
              quoteText: `"I wore this under my gown for my elopement in Sedona. I spent all day trekking around the desert and it didn't roll up or down once!"`,
              author: '- Mazeratie S.',
            },
          ]}
          imgName="qb-quote-1.jpg"
        />
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.QueenBrief]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default BridalLanderMobile;
